import React, { useState } from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

let selectId = 1;

export default function LabelledSelect({ value, onChange, label, options, ...props }) {
  const [id] = useState(() => `select-${selectId++}`);
  const labelId = `${id}-label`;
  return (
    <FormControl {...props} margin="dense" variant="outlined">
      <InputLabel id={labelId} margin="dense" variant="outlined">{label}</InputLabel>
      <Select
        id={id}
        labelId={labelId}
        value={value ? value : ' '}
        onChange={onChange}
        placeholder={props.placeholder}
      >
        {options.map(option => (
          typeof (option) !== 'object'
            ? <MenuItem key={option} value={option}>{option}</MenuItem>
            : <MenuItem
              key={option.value}
              value={option.value}
            >
              {option.label}
            </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
